import client from './main-client';

export const propertiesApi = (params) => client().get(`/properties?userId=${params.userId}&$limit=null&active=true`);

export const addPropertyApi = (data) => client().post('/properties', data);

export const updatePropertyApi = (data) => client().put(`/properties/${data._id}`, data);

export const removePropertyApi = ({ propertyId }) => client().delete(`properties/${propertyId}`);
